module.exports = __webpack_public_path__ + "static/page-banner-digital-product-63b763e29dc553f5e83b19150f08b9e3.png";